export const isSmallScreenUtil = () => window.innerWidth < window.theme?.breakpoints?.large
export const isMobileScreenUtil = () => window.innerWidth < window.theme?.breakpoints?.medium
export const isTabletScreenUtil = () => (
  window.innerWidth > window.theme?.breakpoints.medium &&
  window.innerWidth < window.theme?.breakpoints.large
)
